var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mb-4"},[_c('v-card-title',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),(!_vm.loading)?_c('apexchart',{attrs:{"type":"pie","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }